import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useBankStore } from "../store";

export const updateBank = ({ churchId, bankId, bankData }) => {
  return axios.patch(`/churches/${churchId}/banks/${bankId}`, bankData);
};

export const useUpdateBank = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeUpdateBankAccountModal =
    useBankStore.getState().closeUpdateBankAccountModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("banks");
      queryClient.invalidateQueries("banks-paginated");

      setNotification({
        type: "success",
        message: "Bank updated successfully!"
      });

      closeUpdateBankAccountModal();
    },
    ...config,
    mutationFn: updateBank
  });
};
